module.exports = __webpack_public_path__ + "38e5df8f0c675238b041c029179533e1.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/social/speakers/arun-michael-dsouza.jpg
// module id = 505
// module chunks = 0